import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

import './index.css'

import Protected from './components/Protected'
import Layout from './components/Layout'

import SignIn from './pages/SignIn'
import Campaigns from './pages/Campaigns'
import CampaignNew from './pages/CampaignNew'
import Voters from './pages/Voters'
import VoterDetail from './pages/VoterDetail'
import Dashboard from './pages/Dashboard'
import AuthCallback from './pages/AuthCallback'
import EventDetail from './pages/EventDetail'
import EventSignup from './pages/EventSignup'
import EventQRPrint from './pages/EventQRPrint'
import ContactsPage from './pages/Contacts'
import SettingsUsers from './pages/SettingsUsers'
import SettingsContacts from './pages/SettingsContacts'
import SettingsRelationships from './pages/SettingsRelationships'
import ProfilesPage from './pages/ProfilesPage'
import AccountProfile from './pages/AccountProfile'
import AccountPassword from './pages/AccountPassword'
import ImportVoters from './pages/ImportVoters'
import ImportHistory from './pages/ImportHistory'
import CalendarPage from './pages/Calendar'
import VoterMap from './pages/VoterMap'
import QuickLog from './pages/QuickLog'
import AcceptInvite from './pages/AcceptInvite'
import Events from './pages/Events'
import VoterSimple from "./pages/VoterSimple";

import { CampaignProvider } from './contexts/CampaignContext'

function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/signin" element={<SignIn />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/e/:token" element={<EventSignup />} />

      {/* Print page WITHOUT Layout */}
      <Route
        path="/voters-simple"
        element={
          <Protected>
            <Layout>
              <VoterSimple />
            </Layout>
          </Protected>
        }
      />

      <Route
        path="/events/:id/qr-print"
        element={
          <Protected>
            <EventQRPrint />
          </Protected>
        }
      />

      {/* App routes (with Layout) */}
      <Route
        path="/imports/voters"
        element={
          <Protected>
            <Layout>
              <ImportVoters />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/imports/history"
        element={
          <Protected>
            <Layout>
              <ImportHistory />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/calendar"
        element={
          <Protected>
            <Layout>
              <CalendarPage />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/events"
        element={
          <Protected>
            <Layout>
              <Events />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/events/:id"
        element={
          <Protected>
            <Layout>
              <EventDetail />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/dashboard"
        element={
          <Protected>
            <Layout>
              <Dashboard />
            </Layout>
          </Protected>
        }
      />
      <Route path="/accept-invite" element={<AcceptInvite />} />
      <Route
        path="/campaigns"
        element={
          <Protected>
            <Layout>
              <Campaigns />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/campaigns/new"
        element={
          <Protected>
            <Layout>
              <CampaignNew />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/voters"
        element={
          <Protected>
            <Layout>
              <Voters />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/voters/:id"
        element={
          <Protected>
            <Layout>
              <VoterDetail />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/voters/map"
        element={
          <Protected>
            <Layout>
              <VoterMap />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/profiles"
        element={
          <Protected>
            <Layout>
              <ProfilesPage />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/contacts"
        element={
          <Protected>
            <Layout>
              <ContactsPage />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/settings/users"
        element={
          <Protected>
            <Layout>
              <SettingsUsers />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/settings/contacts"
        element={
          <Protected>
            <Layout>
              <SettingsContacts />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/settings/relationships"
        element={
          <Protected>
            <Layout>
              <SettingsRelationships />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/account/profile"
        element={
          <Protected>
            <Layout>
              <AccountProfile />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/account/password"
        element={
          <Protected>
            <Layout>
              <AccountPassword />
            </Layout>
          </Protected>
        }
      />
      <Route
        path="/log"
        element={
          <Protected>
            <Layout>
              <QuickLog />
            </Layout>
          </Protected>
        }
      />

      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <CampaignProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </CampaignProvider>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)

